import { RuleResult } from '../../../../types/DeclarationP5'

const C0031Validator = {
  validateCustomsOfficeOfTransitEntryIndicatorRequirement: ({
    security,
  }: {
    security: string
  }): RuleResult => (['1', '3'].includes(security) ? 'REQUIRED' : 'NOT_ALLOWED'),
}

export default C0031Validator
